module.exports = __webpack_public_path__ + "img/portomarina.8975d410.jpg";